import styled from 'styled-components';

import {useContext} from 'react';

import {DashboardAdaptiveDensityContext} from '../../../contexts/DashboardAdaptiveDensityContext';
import {getVehicleWarehouseMotBaselineLayout} from '../../../utils/getVehicleWarehouseMotLayout';
import {StyledVisibleMotContent} from '../constants/StyledVisibleMotContent';
import {VehicleWarehouseAdaptiveMotProps} from '../types/VehicleWarehouseAdaptiveMotProps';
import {renderVehicleWarehouseMotContent} from '../utils/renderVehicleWarehouseMotContent';
import {VehicleWarehouseMeasuredMot} from './VehicleWarehouseMeasuredMot';

export function VehicleWarehouseAdaptiveMot(props: VehicleWarehouseAdaptiveMotProps) {
  const coordinator = useContext(DashboardAdaptiveDensityContext);
  const baselineLayout = getVehicleWarehouseMotBaselineLayout(
    props.size,
    props.expiredRows.length,
    props.expiringRows.length
  );

  if (coordinator === null) {
    return (
      <StyledIntrinsicMotContent data-vehicle-warehouse-mot-layout="intrinsic">
        <StyledVisibleMotContent data-vehicle-warehouse-mot-mode={baselineLayout.mode}>
          {renderVehicleWarehouseMotContent(props, baselineLayout)}
        </StyledVisibleMotContent>
      </StyledIntrinsicMotContent>
    );
  }

  return (
    <VehicleWarehouseMeasuredMot
      key={props.size}
      {...props}
      baselineLayout={baselineLayout}
      coordinator={coordinator}
    />
  );
}

const StyledIntrinsicMotContent = styled.div`
  min-width: 0;
`;
